module.exports = __webpack_public_path__ + "static/media/clock_icon.1bb3752a.svg";